import React from 'react';
import { ProjectKeywordGq } from '../../../../../graphql/projects/models/ProjectKeywordGq';
import VoxelLoadingSpinner from '../../../../voxel/Animation/VoxelLoadingSpinner';
import VoxelDataTableCell from '../../../../voxel/DataTable/VoxelDataTableCell';

export interface TableCellmonthPeakProps {
  keyword: ProjectKeywordGq;
}

const mS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const TableCellMonthPeak: React.FC<TableCellmonthPeakProps> = React.memo(({ keyword }) => {
  const month = keyword.peakMonth;

  return (
    <VoxelDataTableCell align="center">
      {keyword.fetchingNewVolume ? (
        <div className="flex flex-row justify-center items-center reative">
          <VoxelLoadingSpinner />
        </div>
      ) : (
        month !== undefined && mS[month - 1]
      )}
    </VoxelDataTableCell>
  );
});

export default TableCellMonthPeak;
